import { ZoomMtg } from "@zoom/meetingsdk";

import {
  ZoomBreakoutRoomInfo,
  ZoomCaptionEvent,
  ZoomMeetingInfo,
  ZoomParticipantInfo,
} from "./types/events";

export function preLoadWasm(): void {
  ZoomMtg.preLoadWasm();
}

export function prepareWebSDK(): void {
  ZoomMtg.prepareWebSDK();
}

export function init(leaveUrl: string) {
  return new Promise<void>((resolve, reject) => {
    ZoomMtg.init({
      debug: import.meta.env.MODE === "development",
      disableCallOut: true,
      disableInvite: true,
      disableZoomLogo: true,
      disableJoinAudio: true,
      disableReport: true,
      disableRecord: true,
      disablePreview: true,
      disableZoomPhone: true,
      disablePictureInPicture: true,
      disableVoIP: true,
      isSupportNonverbal: false,
      isSupportPolling: false,
      leaveUrl: leaveUrl,
      success: () => {
        resolve();
      },
      error: (error: Error) => {
        reject(error);
      },
    });
  });
}

export function joinMeeting(
  sdkKey: string,
  meetingId: string,
  signature: string,
  userName: string,
  userEmail: string,
  tk?: string,
  zak?: string,
  passcode?: string,
) {
  return new Promise<void>((resolve, reject) => {
    ZoomMtg.join({
      sdkKey: sdkKey,
      signature: signature,
      meetingNumber: meetingId,
      userName: userName,
      userEmail: userEmail,
      tk: tk,
      zak: zak,
      passWord: passcode,
      success: () => {
        resolve();
      },
      error: (error: Error) => {
        reject(error);
      },
    });
  });
}

export function getCurrentMeetingInfo(): Promise<ZoomMeetingInfo> {
  return new Promise((resolve, reject) => {
    ZoomMtg.getCurrentMeetingInfo({
      success: (data: ZoomMeetingInfo) => {
        resolve(data);
      },
      error: (error: Error) => {
        reject(error);
      },
    });
  });
}

export function getParticipants(): Promise<ZoomParticipantInfo> {
  return new Promise((resolve, reject) => {
    ZoomMtg.getAttendeeslist({
      success: (data: ZoomParticipantInfo) => {
        resolve(data);
      },
      error: (error: Error) => {
        reject(error);
      },
    });
  });
}

export function getBreakoutRoomInfo(): Promise<ZoomBreakoutRoomInfo> {
  return new Promise((resolve, reject) => {
    ZoomMtg.getCurrentBreakoutRoom({
      success: (data: ZoomBreakoutRoomInfo) => {
        resolve(data);
      },
      error: (error: Error) => {
        reject(error);
      },
    });
  });
}

export function listenForCaptions(callback: (data: ZoomCaptionEvent) => void) {
  ZoomMtg.inMeetingServiceListener(
    "onReceiveTranscriptionMsg",
    function (data: ZoomCaptionEvent) {
      callback(data);
    },
  );
}

export function joinBreakoutRoom(breakoutRoomId: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    ZoomMtg.joinBreakoutRoom({
      roomId: breakoutRoomId,
      success: () => {
        resolve();
      },
      error: (error: Error) => {
        reject(error);
      },
    });
  });
}
